<div *ngIf="variables.length" [formGroup]="form" class="pt-4 pb-2">
  <div *ngFor="let variable of variables" class="mb-4">
    <label class="block text-sm font-medium text-slate-500">{{ variable.label }}</label>

    <input
      *ngIf="variable.type === 'text'"
      type="text"
      class="mt-1 appearance-none block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm placeholder-gray-400 focus:outline-none focus:ring-primary-500 focus:border-primary-500"
      [formControlName]="variable.uuid"
      placeholder="Enter {{ variable.label }}"
      required="true"
    />

    <select
      *ngIf="variable.type === 'select'"
      class="mt-1 block w-full px-4 py-2 text-base border border-gray-300 focus:outline-none focus:ring-primary-500 focus:border-primary-500 rounded-md"
      [formControlName]="variable.uuid"
      required="true"
    >
      <option *ngFor="let option of variable.options?.split(',')" [value]="option">
        {{ option }}
      </option>
    </select>
    <div
      *ngIf="form.get(variable.uuid)?.invalid && form.get(variable.uuid)?.touched"
      class="text-sm text-red-500 mt-1"
    >
      This field is required.
    </div>
  </div>
</div>
